/*
 * Bundle Builder ("Build Your Own Box") for Shrine PRO
 * - Self contained custom element. Does not touch other theme components.
 * - State = an ordered array of "units" (one entry per selected item).
 * - Buy button only unlocks when the box is exactly full (target reached).
 * - Clicking a product opens a clean minimal quick view (never the PDP).
 */
(function () {
  if (customElements.get('bundle-builder')) return;

  /* --- Shopify standard money formatter --------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var match = format.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ''); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function imgUrl(src, width) {
    if (!src) return '';
    var clean = src.split('?')[0];
    return clean + '?width=' + width;
  }

  class BundleBuilder extends HTMLElement {
    constructor() {
      super();
      this.units = [];                 // ordered array of variant ids
      this.products = {};              // productId -> product data
      this.variantIndex = {};          // variantId -> { product, variant }
      this.target = parseInt(this.dataset.defaultSize, 10) || 3;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.addLabel = this.dataset.addLabel || 'Add to Box';
      this.removeLabel = this.dataset.addedLabel || 'Added';
    }

    connectedCallback() {
      // Bind events first so the UI is always responsive even if a single
      // product's data fails to parse.
      this.cacheDom();
      this.bindEvents();
      this.parseProducts();
      try { this.renderTray(); } catch (e) { console.warn('[bundle-builder] render error', e); }
      this._onResize = () => this.syncBarHeight();
      window.addEventListener('resize', this._onResize);
      requestAnimationFrame(() => this.syncBarHeight());
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      clearTimeout(this._barTimer);
      clearTimeout(this._errTimer);
    }

    parseProducts() {
      var nodes = this.querySelectorAll('script[data-bb-product]');
      var ok = 0, bad = 0;
      nodes.forEach((node) => {
        try {
          var p = JSON.parse(node.textContent);
          this.products[p.id] = p;
          (p.variants || []).forEach((v) => {
            this.variantIndex[v.id] = { product: p, variant: v };
          });
          ok++;
        } catch (e) {
          bad++;
          console.warn('[bundle-builder] could not parse product JSON', e, node.textContent.slice(0, 120));
        }
      });
      if (!ok) {
        console.warn('[bundle-builder] no product data loaded (' + nodes.length + ' nodes, ' + bad + ' failed) — Add/Preview will not work.');
      }
    }

    cacheDom() {
      this.grid = this.querySelector('[data-bb-grid]');
      this.tray = this.querySelector('[data-bb-tray]');
      this.slotsEl = this.querySelector('[data-bb-slots]');
      this.progressBar = this.querySelector('[data-bb-progress-bar]');
      this.countEls = this.querySelectorAll('[data-bb-count]');
      this.targetEls = this.querySelectorAll('[data-bb-target]');
      this.subtotalEl = this.querySelector('[data-bb-subtotal]');
      this.checkoutBtn = this.querySelector('[data-bb-checkout]');
      this.quickview = this.querySelector('[data-bb-quickview]');
      this.moreEl = this.querySelector('[data-bb-more]');
      this.qvBody = this.querySelector('[data-bb-qv-body]');
    }

    bindEvents() {
      this.addEventListener('click', (e) => {
        var add = e.target.closest('[data-bb-add]');
        if (add) { e.preventDefault(); this.onCardAdd(add); return; }

        var open = e.target.closest('[data-bb-open]');
        if (open) { e.preventDefault(); this.openQuickView(open.getAttribute('data-bb-open')); return; }

        var size = e.target.closest('[data-bb-size]');
        if (size) { e.preventDefault(); this.setTarget(parseInt(size.getAttribute('data-bb-size'), 10), size); return; }

        var slotRemove = e.target.closest('[data-bb-remove]');
        if (slotRemove) { e.preventDefault(); this.removeUnitAt(parseInt(slotRemove.getAttribute('data-bb-remove'), 10)); return; }

        var qvClose = e.target.closest('[data-bb-qv-close]');
        if (qvClose) { e.preventDefault(); this.closeQuickView(); return; }

        var qvAdd = e.target.closest('[data-bb-qv-add]');
        if (qvAdd) { e.preventDefault(); this.onQuickViewAdd(qvAdd); return; }

        var qvVariant = e.target.closest('[data-bb-qv-variant]');
        if (qvVariant) { e.preventDefault(); this.selectQvVariant(qvVariant); return; }

        var qvThumb = e.target.closest('[data-bb-qv-thumb]');
        if (qvThumb) { e.preventDefault(); this.setQvImage(qvThumb.getAttribute('data-bb-qv-thumb')); return; }

        var toggle = e.target.closest('[data-bb-tray-toggle]');
        if (toggle) {
          e.preventDefault();
          var open = this.classList.toggle('bb--tray-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) {
            // re-measure once the slide-down transition has finished
            clearTimeout(this._barTimer);
            this._barTimer = setTimeout(() => this.syncBarHeight(), 380);
          }
          return;
        }
      });

      if (this.checkoutBtn) {
        this.checkoutBtn.addEventListener('click', (e) => { e.preventDefault(); this.checkout(); });
      }

      this.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && this.quickview && this.quickview.classList.contains('is-open')) {
          this.closeQuickView();
        }
      });
    }

    /* ---- helpers ------------------------------------------------------- */
    firstAvailableVariant(product) {
      return (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
    }

    isFull() { return this.units.length >= this.target; }

    /* ---- add / remove -------------------------------------------------- */
    onCardAdd(btn) {
      var product = this.products[btn.getAttribute('data-bb-add')];
      if (!product) return;
      // Products with real variants must be picked in the quick view.
      if (product.variants && product.variants.length > 1) {
        this.openQuickView(product.id);
        return;
      }
      var v = this.firstAvailableVariant(product);
      if (!v) return;
      this.addUnit(v.id);
    }

    addUnit(variantId) {
      if (this.isFull()) { this.flashFull(); return; }
      if (!this.variantIndex[variantId]) return;
      this.units.push(variantId);
      this.renderTray();
      this.pulseTray();
      // the item landed past the collapsed row — slide the box up so the
      // customer can actually see what they just added
      if (this.units.length > BundleBuilder.MOBILE_ROW && this.target > BundleBuilder.MOBILE_ROW) {
        this.classList.add('bb--tray-open');
        var t = this.querySelector('[data-bb-tray-toggle]');
        if (t) t.setAttribute('aria-expanded', 'true');
      }
    }

    removeUnitAt(index) {
      if (index < 0 || index >= this.units.length) return;
      this.units.splice(index, 1);
      this.renderTray();
    }

    setTarget(n, btn) {
      if (!n || n === this.target) return;
      this.target = n;
      // trim overflow if the new box is smaller
      if (this.units.length > this.target) this.units.length = this.target;
      this.querySelectorAll('[data-bb-size]').forEach((b) => b.classList.remove('is-active'));
      if (btn) btn.classList.add('is-active');
      this.targetEls.forEach((el) => { el.textContent = String(this.target); });
      this.renderTray();
    }

    /* ---- tray rendering ------------------------------------------------ */
    renderTray() {
      var count = this.units.length;
      this.countEls.forEach((el) => { el.textContent = String(count); });
      this.targetEls.forEach((el) => { el.textContent = String(this.target); });

      // slots
      if (this.slotsEl) {
        var html = '';
        for (var i = 0; i < this.target; i++) {
          var vid = this.units[i];
          if (vid != null && this.variantIndex[vid]) {
            var entry = this.variantIndex[vid];
            var img = entry.variant.featured_image || entry.product.featured_image;
            var slotMedia = img
              ? '<img src="' + imgUrl(img, 120) + '" alt="" loading="lazy" width="60" height="60">'
              : '<span class="bb-img-empty" aria-hidden="true"></span>';
            html +=
              '<div class="bb-slot bb-slot--filled">' +
                slotMedia +
                '<button type="button" class="bb-slot__remove" data-bb-remove="' + i + '" aria-label="Remove">' +
                  '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>' +
                '</button>' +
              '</div>';
          } else {
            html += '<div class="bb-slot bb-slot--empty"><span>' + (i + 1) + '</span></div>';
          }
        }
        this.slotsEl.innerHTML = html;
      }

      // progress
      if (this.progressBar) {
        var pct = this.target ? Math.min(100, Math.round((count / this.target) * 100)) : 0;
        this.progressBar.style.width = pct + '%';
      }

      // subtotal
      var subtotal = this.units.reduce((sum, vid) => {
        var entry = this.variantIndex[vid];
        return sum + (entry ? entry.variant.price : 0);
      }, 0);
      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(subtotal, this.moneyFormat);

      // buy gating
      this.updateCheckoutState(count);
      this.updateCardStates();
      this.syncOverflow();
    }

    /* ---- mobile compact box -------------------------------------------- */
    /* Only one row of MOBILE_ROW slots fits in the collapsed box; anything
       beyond that is revealed by sliding the box up. */
    syncOverflow() {
      var hidden = this.target - BundleBuilder.MOBILE_ROW;
      var overflow = hidden > 0;
      this.classList.toggle('bb--overflow', overflow);
      if (!overflow && this.classList.contains('bb--tray-open')) {
        this.classList.remove('bb--tray-open');
      }
      var toggle = this.querySelector('[data-bb-tray-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', this.classList.contains('bb--tray-open') ? 'true' : 'false');
        toggle.hidden = !overflow;
      }
      if (this.moreEl) this.moreEl.textContent = '+' + (overflow ? hidden : 0) + ' more';
      this.syncBarHeight();
    }

    /* Publish the collapsed box height so the product grid can reserve
       exactly that much room and nothing ends up hidden behind it. */
    syncBarHeight() {
      this.syncSlotSize();
      if (!this.tray || this.classList.contains('bb--tray-open')) return;
      var h = this.tray.offsetHeight;
      if (h) this.style.setProperty('--bb-bar-height', h + 'px');
    }

    /* Slots are square, so one row is exactly one tile tall. Publish the
       measured size so the collapsed box clips to a single row on any
       viewport width. */
    syncSlotSize() {
      if (!this.slotsEl) return;
      var first = this.slotsEl.firstElementChild;
      if (!first) return;
      var size = first.offsetWidth;
      if (size) this.style.setProperty('--bb-slot-size', size + 'px');
    }

    updateCheckoutState(count) {
      if (!this.checkoutBtn) return;
      var full = count >= this.target;
      this.checkoutBtn.disabled = !full;
      this.classList.toggle('bb--ready', full);
      var labelEl = this.checkoutBtn.querySelector('[data-bb-checkout-label]');
      if (labelEl) {
        if (full) {
          labelEl.textContent = this.checkoutBtn.getAttribute('data-label-full');
        } else {
          var remaining = this.target - count;
          var tpl = this.checkoutBtn.getAttribute('data-label-remaining') || 'Add {count} more';
          labelEl.textContent = tpl.replace('{count}', remaining);
        }
      }
    }

    updateCardStates() {
      // reflect how many of each product are in the box on its add button
      var counts = {};
      this.units.forEach((vid) => {
        var entry = this.variantIndex[vid];
        if (entry) counts[entry.product.id] = (counts[entry.product.id] || 0) + 1;
      });
      this.querySelectorAll('[data-bb-add]').forEach((btn) => {
        var pid = btn.getAttribute('data-bb-add');
        var n = counts[pid] || 0;
        var labelEl = btn.querySelector('[data-bb-add-label]');
        btn.classList.toggle('is-added', n > 0);
        if (labelEl) labelEl.textContent = n > 0 ? (this.removeLabel + ' · ' + n) : this.addLabel;
        // disable adding when box is full and this product isn't already addable
        btn.toggleAttribute('data-bb-disabled', this.isFull());
      });
    }

    flashFull() {
      if (!this.tray) return;
      this.tray.classList.remove('bb-tray--shake');
      // force reflow to restart animation
      void this.tray.offsetWidth;
      this.tray.classList.add('bb-tray--shake');
    }

    pulseTray() {
      if (!this.tray) return;
      this.tray.classList.remove('bb-tray--pulse');
      void this.tray.offsetWidth;
      this.tray.classList.add('bb-tray--pulse');
    }

    /* ---- quick view ---------------------------------------------------- */
    openQuickView(productId) {
      var product = this.products[productId];
      if (!product || !this.quickview) return;
      this.qvProduct = product;
      this.qvVariant = this.firstAvailableVariant(product);
      this.qvBody.innerHTML = this.quickViewHTML(product);
      this.syncQvVariant();
      this.quickview.classList.add('is-open');
      document.documentElement.classList.add('bb-no-scroll');
      this.quickview.setAttribute('aria-hidden', 'false');
      var closeBtn = this.quickview.querySelector('[data-bb-qv-close]');
      if (closeBtn) closeBtn.focus();
    }

    closeQuickView() {
      if (!this.quickview) return;
      this.quickview.classList.remove('is-open');
      this.quickview.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bb-no-scroll');
    }

    quickViewHTML(product) {
      var images = (product.images && product.images.length ? product.images : [product.featured_image]).filter(Boolean);
      var mainImg = images[0];
      var gallery = images.map((src, i) =>
        '<button type="button" class="bb-qv__thumb' + (i === 0 ? ' is-active' : '') + '" data-bb-qv-thumb="' + src + '">' +
          '<img src="' + imgUrl(src, 160) + '" alt="" loading="lazy"></button>'
      ).join('');

      var variantsHTML = '';
      if (product.variants && product.variants.length > 1) {
        variantsHTML =
          '<div class="bb-qv__variants" role="group" aria-label="Options">' +
            product.variants.map((v) =>
              '<button type="button" class="bb-qv__variant' + (v.id === this.qvVariant.id ? ' is-active' : '') + (v.available ? '' : ' is-soldout') +
                '" data-bb-qv-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
                  v.title +
              '</button>'
            ).join('') +
          '</div>';
      }

      var desc = product.description ? '<div class="bb-qv__desc rte">' + product.description + '</div>' : '';

      var mainMedia = mainImg
        ? '<img data-bb-qv-main src="' + imgUrl(mainImg, 800) + '" alt="' + (product.title || '') + '">'
        : '<span class="bb-img-empty" data-bb-qv-main aria-hidden="true"></span>';

      return '' +
        '<div class="bb-qv__media">' +
          '<div class="bb-qv__main">' + mainMedia + '</div>' +
          (images.length > 1 ? '<div class="bb-qv__thumbs">' + gallery + '</div>' : '') +
        '</div>' +
        '<div class="bb-qv__info">' +
          (product.vendor ? '<p class="bb-qv__vendor">' + product.vendor + '</p>' : '') +
          '<h3 class="bb-qv__title">' + product.title + '</h3>' +
          '<div class="bb-qv__price" data-bb-qv-price></div>' +
          variantsHTML +
          desc +
          '<button type="button" class="bb-qv__add button button--full-width" data-bb-qv-add>' +
            '<span data-bb-qv-add-label>' + this.addLabel + '</span>' +
          '</button>' +
          '<p class="bb-qv__hint" data-bb-qv-hint></p>' +
        '</div>';
    }

    selectQvVariant(btn) {
      var id = parseInt(btn.getAttribute('data-bb-qv-variant'), 10);
      var v = (this.qvProduct.variants || []).find((x) => x.id === id);
      if (!v) return;
      this.qvVariant = v;
      this.qvBody.querySelectorAll('[data-bb-qv-variant]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (v.featured_image) this.setQvImage(v.featured_image);
      this.syncQvVariant();
    }

    setQvImage(src) {
      var main = this.qvBody.querySelector('[data-bb-qv-main]');
      if (main) main.src = imgUrl(src, 800);
      this.qvBody.querySelectorAll('[data-bb-qv-thumb]').forEach((t) => {
        t.classList.toggle('is-active', t.getAttribute('data-bb-qv-thumb') === src);
      });
    }

    syncQvVariant() {
      var priceEl = this.qvBody.querySelector('[data-bb-qv-price]');
      var addBtn = this.qvBody.querySelector('[data-bb-qv-add]');
      var hint = this.qvBody.querySelector('[data-bb-qv-hint]');
      var v = this.qvVariant;
      if (priceEl && v) {
        var html = '<span class="bb-price">' + formatMoney(v.price, this.moneyFormat) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += ' <s class="bb-price-compare">' + formatMoney(v.compare_at_price, this.moneyFormat) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        var soldout = v && !v.available;
        var full = this.isFull();
        addBtn.disabled = soldout || full;
        var label = addBtn.querySelector('[data-bb-qv-add-label]');
        if (label) label.textContent = soldout ? 'Sold out' : (full ? 'Box is full' : this.addLabel);
      }
      if (hint) hint.textContent = this.isFull() ? 'Your box is full — remove an item to swap.' : '';
    }

    onQuickViewAdd() {
      if (!this.qvVariant || !this.qvVariant.available) return;
      this.addUnit(this.qvVariant.id);
      this.syncQvVariant();
      if (this.isFull()) {
        this.closeQuickView();
      }
    }

    /* ---- checkout ------------------------------------------------------ */
    checkout() {
      if (this.units.length < this.target) return;
      var routes = (window.routes && window.routes.cart_add_url) ? window.routes : { cart_add_url: '/cart/add', cart_url: '/cart' };

      // group identical variants into quantities
      var grouped = {};
      this.units.forEach((vid) => { grouped[vid] = (grouped[vid] || 0) + 1; });

      var bundleId = 'box-' + Date.now();
      var items = Object.keys(grouped).map((vid) => ({
        id: parseInt(vid, 10),
        quantity: grouped[vid],
        properties: {
          _bundle: (this.dataset.bundleName || 'Build Your Own Box') + ' (' + this.target + ')',
          _bundle_id: bundleId
        }
      }));

      this.setCheckoutLoading(true);
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: items })
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status && data.status >= 400) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          window.location.href = routes.cart_url || '/cart';
        })
        .catch((err) => {
          this.setCheckoutLoading(false);
          this.showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
        });
    }

    setCheckoutLoading(loading) {
      if (!this.checkoutBtn) return;
      this.checkoutBtn.classList.toggle('bb-loading', loading);
      this.checkoutBtn.disabled = loading || this.units.length < this.target;
    }

    showError(msg) {
      var el = this.querySelector('[data-bb-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this._errTimer);
      this._errTimer = setTimeout(() => { el.hidden = true; }, 5000);
    }
  }

  // slots visible in the collapsed mobile box (must match the CSS grid)
  BundleBuilder.MOBILE_ROW = 4;

  customElements.define('bundle-builder', BundleBuilder);
})();
